import styled from "styled-components";
export const HomeContainer = styled.div`
  .banner {
    img {
      width: 100%;
    }
  }
  .main {
    background-image: url("/content-bg.png");
    background-position: top;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    margin-top: 0px;
    padding-top: 16px;
    .slogan-area {
      font-family: Mj_Hili;
      padding-top: 32px;
      padding-bottom: 108px;
      position: relative;
      .right {
        font-size: 32px;
        line-height: 48px;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        border-left: solid 1px #181817;
        .small-span {
          letter-spacing: 1.3px;
        }
      }
      .left {
        padding-right: 32px !important;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        .title {
          font-size: 40px;
          padding-bottom: 8px;
        }
        .text {
          font-family: Ravi;
          font-size: 18px;
          font-weight: 300;
          color: ${({ theme }) => theme.colors.lightFont};
        }
        .buttons {
          margin-top: 18px;
          button {
            margin-left: 16px;
            padding: 4px 24px;
          }
        }
      }
      /* &::after {
        content: "";
        position: absolute;
        background: #cb6a44;
        width: 68px;
        height: 24px;
        bottom: 32px;
        left: calc(50% - 34px);
      } */
    }
    .car-pic {
      width: 100%;
      padding-left: 24px;
    }
    .content {
      padding: 8px 0;
      padding-right: 28px;
      .text {
        font-family: Ravi;
        font-size: 18px;
        font-weight: 300;
        color: ${({ theme }) => theme.colors.lightFont};
      }
    }
    .video {
      padding: 32px 0;
      text-align: center;
      video {
        width: 75%;
      }
    }
  }
  @media only screen and (max-width: 1024px) {
    padding-bottom: 32px;
  }
  @media only screen and (max-width: 760px) {
    padding-bottom: 32px;
    .main {
      background-size: 100%;
      margin-top: 0px;
      padding-top: 10px;
      .slogan-area {
        padding-top: 16px;
        padding-bottom: 80px;
        .right {
          font-size: 24px;
          line-height: 36px;
          border-left: none;
          display: block;
          text-align: center;
        }
        .left {
          padding-right: 32px !important;
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          .title {
            font-size: 18px;
            padding-bottom: 8px;
            padding-top: 32px;
          }
          .text {
            font-size: 12px;
          }
        }
      }
      .car-pic {
        width: 100%;
        padding-left: 0;
      }
      .content {
        padding-right: 0;
        .text {
          font-size: 12px;
        }
      }
    }
    .video {
      video {
        width: 100% !important;
      }
    }
  }
`;
